import { METHOD } from "../utils/Constant";
import { URL } from "../utils/Config";
import {
  getApiClient,
  getFullAuthHeaders
} from "./base";
export const registeredEmp = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.LIST_OF_EMPLOYEES_STATUS,
    params,
  });
};

export const logout = () => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.LOGOUT,
  });
};

